import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  FabDateFilterComponent,
  FabDateFilterOperator,
  FabNumberFilterComponent,
  FabStringFilterComponent
} from '@fabric/components/table-filter';
import { FabTableState, filterStateChange, process } from '@fabric/components/table-filter/data-query';
import { MaintenanceTpre } from 'src/app/models/MaintenanceTpre';
import { NotificationService } from 'src/app/services/notification.service';
import { SecurityService } from 'src/app/services/security.service';
import { catchError, concat, forkJoin, map, Observable, ObservableInput, of } from 'rxjs';
import { TpreService } from 'src/app/services/tpre.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserFunctionCode } from 'src/app/constants/UserFunctionCode';
import {
  PopupCancelDialogComponent
} from 'src/app/shared-components/popup-cancel-dialog/popup-cancel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ErrorCodes } from 'src/app/constants/ErrorCodes';

@Component({
  selector: 'app-tpre-maintenance',
  templateUrl: './tpre-maintenance.component.html',
  styleUrls: ['./tpre-maintenance.component.scss']
})
export class TpreMaintenanceComponent implements OnInit {
  columnsToDisplay: string[] = ["codTpre", "descTpre", "onHold",
  "estado","fecCreacion","usrCreacion","fecModif",
"usrModif","isEdit"];

  dataSource: MatTableDataSource<MaintenanceTpre> = new MatTableDataSource<MaintenanceTpre>();
  rowsToModify: any = [];
  rowsToAdd: any = [];

  TABLE_DATA: MaintenanceTpre[] = [];
  ORIGINAL_TABLE_DATA: MaintenanceTpre[] = [];
  columnsSchema: any = this.columnsToDisplay;
  operators = ['contains', 'eq', 'neq'];
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  canAddOrEdit: boolean = false;
  today: object = new Date();
  // @ts-ignore
  currentDate = this.today.toISOString().split('T')[0];
  resultsLength = 0;
  pageSize = 10;
  state: FabTableState = {
      skip: 0,
      take: 5,
      filter: [],
      sort: []
  };
  selector: string;

  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false}) sort!: MatSort;
  @ViewChildren('tableFilter') tableFilters: QueryList<FabStringFilterComponent | FabNumberFilterComponent | FabDateFilterComponent>;

  public get saveButtonDisabled() {
    return (this.TABLE_DATA.filter(element => element.isEdit).length == 0 &&
      this.TABLE_DATA.filter(element => element.isAdd).length == 0) ||
      !this.validateAllRows()
  }

  public isDirty(row: MaintenanceTpre, column: string) {

    var toReturn;

    if(row.isAdd){
      toReturn = false;
    } else {

    // @ts-ignore
    toReturn = (row[column] != row.originalData[column])
    }


    return toReturn;
  }


  constructor(
    private notificationService: NotificationService,
    private securityService: SecurityService,
    public dialog: MatDialog,
    private tpreService: TpreService,
    private elementRef: ElementRef) {
  }

  ngOnInit(): void {
      this.fetchData();
      this.canAddOrEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
      this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.processData;
  }

  public filterChange(event:any) {
    this.state.skip = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.processData();
}


// process your local data and assign it to the datasource
// <your data> is an array of objects whose keys match up to the table columns
  private fetchData(){

    this.tpreService.getTpreTable().subscribe(
      (data: any) => {

        this.dataSource.data = process(data as any[], this.state)
        for(const row of this.dataSource.data){
          row.isEdit = false;
          row.isAdd = false;
          row.isSave = false;
          row.originalData = JSON.parse(JSON.stringify(row));
        }

        this.TABLE_DATA = data as any[];
        this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
          return item.estado !== false;
        })



        this.sortTableById();
        this.processData();
        console.log(this.TABLE_DATA);

      },
      (err: string) => {
        this.notificationService.open(err, 'error');
      }
    )
  }

  refresh(){
    this.dialog
        .open(PopupCancelDialogComponent)
        .afterClosed()
        .subscribe((confirm: any) => {
            if (confirm) {
                this.fetchData();
            }
        })
      }



  processData() {
    this.dataSource.data = process(this.TABLE_DATA, this.state);
  }


  sortTableById() {
    this.TABLE_DATA.sort((a, b) => {
      // @ts-ignore
      return b.id - a.id;
    });
  }


  addRow() {
      // console.log("add row");
      let newRow = new MaintenanceTpre;
      newRow.onHold = false;
      newRow.estado = true;
      newRow.isAdd = true;
      newRow.isSave = true;
      newRow.usrCreacion = this.securityService.LOGGED_USER['gmin'];
      this.dataSource.data.unshift(newRow);

      this.processData();
  }


  editRow(row: MaintenanceTpre) {
    // console.log("edit row");
      if (!row.isAdd) {
          row.isEdit = true;
          row.isSave = true;
          row.usrModif = this.securityService.LOGGED_USER['gmin'];
      }

      if (row.isAdd) {
        row.isEdit = true;
    }
  }



  cancelRow(row: MaintenanceTpre) {

    if(row.isAdd) {
      this.TABLE_DATA = this.TABLE_DATA.filter((item) => {
        return item !== row;
      })
    } else {

      // console.log(row.originalData);

      row.id = row.originalData.id;
      row.codTpre = row.originalData.codTpre;
      row.descTpre = row.originalData.descTpre;
      row.onHold = row.originalData.onHold;
      row.estado = row.originalData.estado;
      row.usrModif = row.originalData.usrModif;

      row.isSave = false;
      row.isEdit = false;

    }


    this.processData();
  }



  save() {
    let inactiveObservables: ObservableInput<any>[] = [];
    let activeObservables: ObservableInput<any>[] = [];
    let errors: HttpErrorResponse[] = [];
    let saved = 0;
    let firstValidation: Boolean = this.validateAllRows();

    if(firstValidation){
      this.TABLE_DATA.filter((item) => item.isSave)
      .forEach((row) => {
        let observableType = row.estado ? activeObservables : inactiveObservables;
        console.log("test");
        console.log(observableType);
        observableType.push(
            this.tpreService.addUpdateTpre(row, row.isAdd)
            .pipe(
              map((res: MaintenanceTpre) => {
                console.log("Response: ");
                console.log(row);
                console.log(res);
                console.log(res.codTpre);
                row.originalData = res;
                row.isEdit = false;
                row.isAdd = false;
                row.isSave = false;
                row.id = res.id;
                row.fecModif = res.fecModif;
                saved++;
              }),
              catchError((err: HttpErrorResponse) => {
                errors.push(err);
                return of(null);
              })
            )
          );
        }
      );

      concat(forkJoin(inactiveObservables), forkJoin(activeObservables)).subscribe({
        next: undefined,
        error: undefined,
        complete: () => {
          if (errors.length == 0) {
            this.notificationService.open(ErrorCodes.SAVED, 'success');
            this.sortTableById();
            this.processData();
          } else {
            const errorCounts = errors.map(err => err.error.errorMessage).reduce((accumulator, value) => {
              // @ts-ignore
              return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            let errorMessage = `${saved} rows saved. ${errors.length} rows have errors:`
            .concat(...Object.entries(errorCounts).map(([msg, count]) => `\n${msg} (${count})`));
            this.notificationService.open(errorMessage, 'error');
          }
        }
      });
    } else {
        this.notificationService.open(ErrorCodes.INVALID_DATA, 'error');
    }
}

  private validateRow(row: MaintenanceTpre) {

    return /^([0-9]{1,2})$/.test(row.codTpre) &&
    row.codTpre.length == 2 &&
    row.descTpre.length > 0 &&
    row.descTpre.length <= 50 &&
    row.onHold !== null  &&
    !this.idExistsInTable(row);
  }

  public validateAllRows() {
    return this.TABLE_DATA.filter(element => element.isSave).every((row) => this.validateRow(row))
  }

  private dirtyCheck(): boolean {
    return !this.TABLE_DATA.every((row) => {
      return !row.isEdit;
    })
  }

  idExistsInTable(row: MaintenanceTpre) {
    if (row.estado) {
      return this.TABLE_DATA.filter((element) => {
        return row != element &&
          row.codTpre == element.codTpre &&
          element.estado;

      }).length > 0;
    } else {
      return false;
    }
  }

  checkId(row: MaintenanceTpre, control: MatFormField) {
    if(row.codTpre.length < 2){
      this.notificationService.open(ErrorCodes.TPRE_LENGTH, "warn");
      control._control.ngControl?.control?.setErrors({'length-error':true});
    }else if (this.idExistsInTable(row)) {
      this.notificationService.open(ErrorCodes.DUPLICATE_TPRE, "warn");
      control._control.ngControl?.control?.setErrors({'id-already-exists':true});
    }
  }



  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.dirtyCheck()) {
      return confirm("You have unsaved changes. Leave page anyway?");
    } else {
      return true;
    }
  }
}
